import React from 'react';
import { Calendar } from '@mantine/dates';
import classes from './Calendar.module.css';
import { dayRenderer } from './Calendar.day-render';
import dayjs from 'dayjs';
import { EventsByDay } from '../types';
import { LoadingOverlay, Box } from '@mantine/core';

export const EventsCalendar: React.FC<{
  events: EventsByDay;
  maxDate: string;
  minDate: string;
  currentDate: string;
  handleDateChange: (date: string) => void;
  isLoading: boolean;
  handleSelectDate: (date: string) => void;
  selectedDate: string;
  isRefetching: boolean;
}> = ({
  events,
  maxDate,
  minDate,
  currentDate,
  handleDateChange,
  isLoading,
  handleSelectDate,
  selectedDate,
  isRefetching,
}) => {
  return (
    <Box pos="relative" mt="md" mb="xl">
      <LoadingOverlay visible={isLoading || isRefetching} opacity={0.5} />
      <Calendar
        firstDayOfWeek={0}
        date={currentDate}
        minDate={minDate}
        maxDate={maxDate}
        onDateChange={handleDateChange}
        renderDay={(date) => dayRenderer({ date, events })}
        withCellSpacing={false}
        classNames={classes}
        getDayProps={(date) => {
          const isPastDay = dayjs(date).isBefore(dayjs(), 'day');
          const isAfterMaxDate = dayjs(date).isAfter(maxDate);
          return {
            onClick: () => handleSelectDate(date),
            style: {
              opacity: isPastDay || isAfterMaxDate ? 0.5 : 1,
              borderRadius: 0,
              background: isPastDay || isAfterMaxDate ? 'var(--mantine-color-gray-1)' : 'white',
              border:
                date === selectedDate
                  ? '1px solid var(--mantine-color-black)'
                  : '1px solid var(--mantine-color-transparent)',
            },
          };
        }}
        styles={{
          day: {
            height: '140px',
            width: '100%',
            color: 'var(--mantine-color-text)',
            display: 'flex',
            flexDirection: 'column',
            padding: '4px',
          },
        }}
        maxLevel="month"
      />
    </Box>
  );
};

export default EventsCalendar;
